import { CatalogEnvService } from "@aipb/gulliver/catalog/env";
import { CatalogRecHeader, CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { StripHtmlPipe } from '@aipb/shared/ui/pipes';
import { truncate as fnTruncate } from '@aipb/shared/util/string';

import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

@Component({
  selector: 'cat-header-label',
  templateUrl: './header-label.component.html',
  styleUrls: ['./header-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [StripHtmlPipe]
})
export class HeaderLabelComponent {
  @Input() item: CustomRecordItem;
  @Input() header: CatalogRecHeader;
  @Input() compact = false;

  private catalogEnv = inject(CatalogEnvService);

  getLabel(truncate = false): string {
    if (!this.header) {
      return '';
    }

    if (truncate && this.catalogEnv.env.truncateHeaderLabel) {
      return fnTruncate(this.header.label.value, this.catalogEnv.env.truncateHeaderLabel);
    }

    return this.header.label.value;
  }

  getSublabel(truncate = false): string {
    if (!this.header) {
      return '';
    }

    if (truncate && this.catalogEnv.env.truncateHeaderLabel) {
      return fnTruncate(this.header.sublabel.value, this.catalogEnv.env.truncateHeaderLabel);
    }

    return this.header.sublabel.value;
  }
}
